module.exports = __webpack_public_path__ + "img/颈管腺.a5e54160.png";